import { faChevronRight, faCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Accordion } from "@szhsin/react-accordion"
import { mockIndustry, mockList, mockProductsData } from "../../../mock"
import Footer from "../../footer"
import NavBar from "../../nav"
import AccordionItem from "../../nav/accordion-item"
import './index.scss'

const About = () => {
  return <div>
    <NavBar />
    <div className='about'>
      <div className='about__breadcumb'>
        <p>Compliance Services</p> <FontAwesomeIcon icon={faChevronRight} /> <p>About Fly Compliant</p>
      </div>
      <p className='about__header'>About Fly Compliant</p>
      <p className='about__description'>Fly Compliant, LLC is the leader in regulatory compliance specializing in FAA requirements. Since 1998 Fly Compliant, LLC has been providing every level of service to include:</p>
      <div className='about__list'>
        {mockList.map((list, idx) => <p key={idx}><FontAwesomeIcon icon={faCircle} />{list}</p>)}
      </div>
    </div>
    <div className='industry'>
      <p className='industry__header'>Pioneering the Industry</p>
      {mockIndustry.map((item, idx) =>
        <Accordion key={idx} transition transitionTimeout={250}>
          <AccordionItem header={item.title} chevronPosition='before' lastItem={!!(idx === mockIndustry.length - 1)}>
            <p className='industry__accordion--content'>{item.content}</p>
            <p className='industry__accordion--content--link'>{item.link}</p>
          </AccordionItem>
        </Accordion>)}
    </div>
    <div className='products'>
      <p className='products__header'>Products & Services</p>
      <div className='products__grid'>
        {mockProductsData.map((product, idx) => <div key={idx} className='products__block-text'>
          <p>{product.title}</p>
          <p>{product.content}</p>
          {product.link}
        </div>)}
      </div>
    </div>
    <Footer />
  </div >
}

export default About